<template>
  <form class="main flex-column" @submit="onSubmit">
    <div class="header">
      <div class="flex-row-xs flex-middle flex-wrap">
        <a href="https://www.shouqianba.com" class="logo">
          <img alt="收钱吧 - 生意好，收钱吧！" src="https://wosai-statics.oss-cn-hangzhou.aliyuncs.com/form-fe/logo3.png" />
        </a>
        <div class="title">
          <h1 class="flex-item">收钱吧合作伙伴申请表</h1>
          <section>
            感谢选择收钱吧！请详细填写相关资料，我们会安排渠道经理与您沟通合作要求！
          </section>
        </div>
      </div>
      <div class="line"></div>
    </div>
    <div class="flex-item body">
      <Input placeholder="姓名" v-model="name" />
      <Input placeholder="手机号" v-model="cellphone" />
      <Input placeholder="公司名称" v-model="firm" />
      <Input placeholder="所属行业" v-model="industry" />
      <Input placeholder="资源状况" v-model="resource" />
      <Region
        placeholder="意向省市"
        v-model="regions"
        :labels="['省份', '城市']"
      />
    </div>
    <div class="agreed">
      <input
        type="radio"
        name="agreed"
        v-model="agreed"
        value="agreed"
        @click="onAgreed"
        class="agreed-input"
      />
      同意
      <a
        v-for="item in protocolList"
        class="agreed-href"
        :href="item.url"
        target="_blank"
        >《{{ item.name }}》</a
      >
    </div>
    <div class="footer flex-row flex-center">
      <button
        :class="{ 'flex-item submit btn': 1, disabled: submitted }"
        type="submit"
      >
        提交申请
      </button>
    </div>
  </form>
</template>
<script>
import dayjs from "dayjs";
import Enum from "../../enums";
import { Form, Input, Region } from "../../components";
import {
  getReferer,
  storage,
  isApp,
  getMerchantRedirectURL,
  checkPhone,
} from "../../utils";

export default {
  components: {
    Form,
    Input,
    Region,
  },
  metaInfo: {
    meta: [
      {
        name: "keyWords",
        content: "收钱吧,合作伙伴,申请表",
      },
      {
        name: "description",
        content: "收钱吧合作伙伴申请表",
      },
    ],
  },
  data() {
    return {
      submitted: false,
      submitting: false,
      name: "",
      firm: "",
      cellphone: "",
      resource: "",
      industry: "",
      regions: [],
      start: dayjs(),
      agreed: false,
      protocolList: [
        {
          sn: "sqb_privacy_web20231027",
          name: "收钱吧隐私政策",
          url: "https://images.wosaimg.com/5c/a901cd3de7fd32c93fc9336244d16b1fa67b43.html",
        },
      ],
    };
  },
  computed: {
    disabled() {
      return this.submitted;
    },
  },
  mounted() {
    this.initProtocol();
  },
  methods: {
    onAgreed() {
      this.agreed = !this.agreed;
    },
    async initProtocol() {
      const { code, message, data } = await this.$axios.post(
        "/form/agreement",
        {
          types: ["sqb_privacy_web"],
        }
      );
      if (data && data.length) {
        const list = data.filter((item) => {
          return item;
        });
        if (list && list.length) {
          this.protocolList = list;
        }
      }
      console.log(code, message, data);
    },

    async onSubmit(e) {
      e.preventDefault();
      if (this.submitting) {
        return;
      }
      if (this.checked()) {
        if (!this.agreed) {
          this.$toast(
            `请阅读${this.protocolList.map(
              (item) => `《${item.name}》`
            )}，并勾选同意`
          );
          return;
        }
        const { name, cellphone, firm, industry, resource, regions, start } =
          this;
        const [{ name: province }, { name: city }] = regions;
        this.submitted = true;
        // let referer = storage(Enum.MERCHANT_REFERER_CACHE_KEY);
        // if (!referer || referer.submitted) {
        let referer = getReferer();
        // }
        const timeUsed = (dayjs() - start) / 1000;
        this.submitting = true;
        const { code, message, data } = await this.$axios.post(
          "/form/provider",
          {
            name,
            cellphone,
            firm,
            industry,
            resource,
            province,
            city,
            timeUsed,
            agreementSn: this.protocolList.map((item) => item.sn).join(","),
            ...referer,
          }
        );
        if (code === 200) {
          this.submitted = true;
          storage(Enum.MERCHANT_REFERER_CACHE_KEY, {
            ...referer,
            submitted: true,
          });
          this.$toast("问卷已提交成功");
        } else {
          this.submitted = false;
          this.$toast(message);
        }
        this.submitting = false;
      }
    },
    checked() {
      const { name, cellphone, firm, resource, regions, industry } = this;
      if (!name) return this.$toast("请填写申请人姓名");
      if (!cellphone) return this.$toast("请填写申请人手机号码");
      if (!checkPhone(cellphone)) return this.$toast("手机号码格式不正确");
      if (!firm) return this.$toast("请填写公司名称");
      if (!industry) return this.$toast("请填写所属行业");
      if (!resource) return this.$toast("请选择资源状况");
      if (regions.length < 2) return this.$toast("请选择省市");
      return true;
    },
  },
  created() {
    const referer = getReferer();
    if (
      ![1, 2].includes(referer.refererType) &&
      !storage(Enum.MERCHANT_REFERER_CACHE_KEY)
    ) {
      storage(Enum.MERCHANT_REFERER_CACHE_KEY, referer);
      window.location.href = getMerchantRedirectURL();
    }
  },
};
</script>

<style lang="scss" scoped>
.logo {
  display: block;
  padding: 1rem;
  margin: 0 auto;
  text-align: center;
  img {
    width: 13.6rem;
  }
}
.agreed {
  color: #666 !important;
  margin: 2px 14px;
  font-size: 12px;
}

.agreed-href {
  text-decoration: none;
  color: #d9af5c;
}

.agreed-input {
  vertical-align: text-bottom;
}

.line {
  height: 3px;
  background: #e39b0e;
  margin: 0.8rem 0 0;
}

.body {
  overflow-y: auto;
  padding-top: 2rem;
}

.title {
  padding: 0 1rem;
  font-size: 1.2rem;
  font-weight: 300;
  line-height: 2rem;
  h1 {
    font-size: 2rem;
    font-weight: 400;
    line-height: 2.5rem;
  }
}

.title-min {
  padding: 0.5rem 1rem;
  margin-bottom: 2rem;
  font-size: 1.6rem;
  font-weight: 400;
  color: #e39b0e;
  border-bottom: 1px solid #eee;
  span {
    display: inline-block;
    font-size: 1rem;
    color: #ff0000;
  }
}

.send {
  position: relative;
  padding: 0.5rem 0;
  font-size: 1.2rem;
  cursor: pointer;
  width: 35%;
  min-width: 10rem;
  text-align: center;
  z-index: 1;
  &:after {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 200%;
    height: 150%;
    display: block;
    pointer-events: none;
    content: "";
    border: 1px solid #333;
    border-radius: 0.5rem;
    margin-top: -1px;
    transform: translate(-50%, -50%) scale(0.5);
  }
  &.disabled {
    &:after {
      border-color: #ccc;
    }
  }
}

.submit {
  max-width: 40rem;
}

@media screen and (max-width: 600px) {
  .felx-wrap {
    align-items: center;
  }
  .logo {
    padding: 1.2rem 0;
    width: 5.5rem;
    height: 5.5rem;
    overflow: hidden;
    padding-left: 1.4rem;
    img {
      transform: translate(-0.4rem);
    }
  }
  .title {
    flex: 1;
    padding-top: 1.5rem;
    font-size: 1.2rem;
    h1 {
      font-size: 1.8rem;
      line-height: 2rem;
    }
    section {
      color: #999;
    }
  }
}
</style>


